export const it = {
  main: {
    color_hex: 'Colore in notazione esadecimale, inizia con #',
    language: 'Italiano',
    restricted_field_name: 'Questo nome di campo è riservato e non può essere utilizzato',
    asset_type_required: 'Seleziona almeno un tipo di asset o rendi il campo globale',
    searchbar: 'Cerca (minimo 3 caratteri)',
    title: 'Admin',
    logout: 'Disconnettersi',
    english: 'Inglese',
    dutch: 'Olandese',
    french: 'Francese',
    spanish: 'Spagnolo',
    danish: 'Danese',
    italian: 'Italiano',
    romanian: 'Rumeno',
    norwegian: 'Norvegese',
    german: 'Tedesco',
    drop_image: 'Trascina qui la tua immagine',
  },
  ra: {
    tree: {
      add_child_node: 'Aggiungi sottocategoria',
      add_node_after: 'Aggiungi categoria dopo',
      add_node_before: 'Aggiungi categoria per',
      close: 'Vicino',
      expand: 'Aprire',
    },
  },
  resources: {
    categories: {
      name: 'Categoria |||| Categorie',
      fields: {
        name: 'Nome della categoria',
      },
    },
    users: {
      name: 'Utente  |||| Utenti',
      fields: {
        category: 'Categoria',
        connection: 'Connessione',
        email: 'E-mail',
        familyName: 'Cognome',
        firstName: 'Nome di battesimo',
        language: 'Linguaggio',
        userRoles: 'Ruoli',
      },
    },
    priorities: {
      name: 'Priorità |||| Priorità',
    },
    branding: {
      name: 'Logo',
    },
    invitations: {
      name: 'Invito |||| Inviti',
      fields: {
        email: 'E-mail',
      },
    },
    'asset-types': {
      name: 'Tipo di asset |||| Tipi di asset',
      fields: {
        name: 'Nome',
      },
    },
    'asset-statuses': {
      name: "Stato dell'asset |||| Stati dell'asset",
      fields: {
        name: 'Nome',
      },
    },
    'asset-custom-fields': {
      name: "Campo personalizzato dell'asset |||| Campi personalizzati dell'asset",
      fields: {
        name: 'Nome',
        globalField: 'Globale (tutti i tipi di asset)',
        assetTypeIds: 'Tipi di asset',
      },
    },
  },
}
